import React from 'react'
import ShapesSection from './ShapesSection'
import ShapeThumbItem from './ShapeThumbItem'

const SavedShapesSection = ({
    items,
    loading,
    error,
    skeletonCount,
    pagination,
    title = 'Saved Shapes',
    emptyComponent = <p className="SidebarPanel__Empty">No items yet.</p>,
    onSelectShape,
    onEditShape,
    onDeleteShape,
}) => {
    return (
        <ShapesSection
            title={title}
            loading={loading}
            error={error}
            items={items}
            skeletonCount={skeletonCount}
            emptyComponent={emptyComponent}
            pagination={pagination}
            renderItem={(template) => (
                <ShapeThumbItem
                    item={template}
                    itemKey={template._id}
                    buttonClassName="SidebarPanel__ShapeThumb SidebarPanel__ShapeThumb--card"
                    ariaLabel={template.name || 'Shape'}
                    onClick={onSelectShape}
                    onDelete={onDeleteShape}
                    deleteAriaLabel="Delete shape"
                    actions={
                        typeof onEditShape === 'function'
                            ? [
                                  {
                                      key: 'edit',
                                      className: 'SidebarPanel__ShapeThumbAction SidebarPanel__ShapeThumbAction--edit',
                                      onAction: onEditShape,
                                      ariaLabel: 'Edit shape',
                                      content: 'Edit',
                                  },
                              ]
                            : []
                    }
                >
                    <div className="SidebarPanel__ShapeThumbImgWrap">
                        {template.preview_image ? (
                            <img
                                src={template.preview_image}
                                alt={template.name || 'Shape preview'}
                                className="SidebarPanel__ShapeThumbImg"
                            />
                        ) : (
                            <span className="SidebarPanel__ShapeThumbPlaceholder">No preview</span>
                        )}
                    </div>
                    <span className="SidebarPanel__ShapeThumbName">{template?.name}</span>
                </ShapeThumbItem>
            )}
        />
    )
}

export default SavedShapesSection
